module.exports = __webpack_public_path__ + "static/media/pfizer.97602c36.png";